import { useEffect, useState } from 'react';

export type Viewport = 'mobile' | 'tablet' | 'desktop';

const TABLET_QUERY = '(min-width: 768px)';
const DESKTOP_QUERY = '(min-width: 1024px)';

function read(): Viewport {
  if (typeof window === 'undefined' || !window.matchMedia) return 'mobile';
  if (window.matchMedia(DESKTOP_QUERY).matches) return 'desktop';
  if (window.matchMedia(TABLET_QUERY).matches) return 'tablet';
  return 'mobile';
}

export function useViewport(): Viewport {
  const [vp, setVp] = useState<Viewport>(read);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const desktopMql = window.matchMedia(DESKTOP_QUERY);
    const tabletMql = window.matchMedia(TABLET_QUERY);
    const onChange = () => setVp(read());
    desktopMql.addEventListener('change', onChange);
    tabletMql.addEventListener('change', onChange);
    setVp(read());
    return () => {
      desktopMql.removeEventListener('change', onChange);
      tabletMql.removeEventListener('change', onChange);
    };
  }, []);

  return vp;
}
